module.exports = __webpack_public_path__ + "img/server.9355bb5b.svg";